<template>
    <tuango-portlet class="box blue">
        <div slot="title" class="portlet-title">
            <div slot="caption" class="caption">
                <i class="icon-credit-card"></i>
                <slot>Cards</slot>
            </div>
            <div slot="actions" class="actions">
            </div>
        </div>
        <div slot="body">
            <tuango-datatables :tableData="cards"
                               :headers="headers"
                               :buttons="buttons"></tuango-datatables>
        </div>
    </tuango-portlet>
</template>

<script>
  import TuangoDatatables from '@/app/components/datatables/Datatable'
  import TuangoPortlet from '@/app/components/Portlet'

  export default {
    name: 'table-cards',
    props: {
      cards: {
        type: Array,
        required: true
      }
    },
    components: {
      TuangoDatatables,
      TuangoPortlet
    },
    data () {
      return {
        headers: [
          {title: 'Type', prop: 'type'},
          {title: 'Number', prop: 'ccFirstLast'},
          {title: 'Status', prop: 'isActive'},
          {title: 'MCStatus', prop: 'isMastercardActive'}
        ],
        buttons: [
          {
            extend: 'copy',
            className: 'dt-button btn default'
          },
          {
            extend: 'print',
            className: 'dt-button btn default'
          },
          {
            extend: 'csv',
            className: 'dt-button btn default'
          }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/user/Cards.vue